export default "__VITE_ASSET__C6t0kK_5__"